/**
 * Se la stringa termina in '/' non fa nulla altrimenti lo aggiunge.
 * @param string stringa
 * @returns stringa con '/' finale.
 */
function concatSlash(string) {
    let result = string;
    if (result && !result.endsWith('/')) {
        result += '/';
    }
    return result;
}

export { concatSlash };
